export default "__VITE_ASSET__Bon3aYku__"